/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CategoriesCollection(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CategoriesCollection',
      'aria-hidden': true,
      focusable: false,
      width:  11 * scale,
      height: 11 * scale,
      viewBox: '0 0 11 11',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M5 1.166 1 3.6 5 6l4-2.4zM0 3l5-3 5 3v5l-5 3-5-3z","fill":"currentColor","fillRule":"nonzero"}))
}
